/*
 * Fabric quantity handling for Avone.
 *
 * Fabric (every product WITHOUT the "MOTIF" tag) is sold in 0.1 m (10 cm)
 * increments with a 1 m minimum. Shopify's cart only accepts whole-number
 * line quantities, so internally 1 cart unit = 10 cm and 1 metre = 10 units.
 * Variant prices are entered in the admin per 10 cm, so the "per metre" price
 * shown to customers is the unit price x 10.
 *
 * Each fabric quantity widget is a container holding:
 *   - one VISIBLE <input data-fabric> showing the length in metres (step 0.1)
 *   - one HIDDEN  <input data-fabric-units> carrying the 10 cm unit count that
 *     is actually submitted to Shopify (name="quantity" on a product form,
 *     name="updates[]" in the cart form).
 *
 * This script keeps the hidden unit count in sync with the visible metres
 * value and refreshes the live "per metre" running total on the product page.
 */
(function () {
  'use strict';

  var PER_M = 10; // 10 cm units per metre

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {
      /* fall through */
    }
    return (cents / 100).toFixed(2);
  }

  // Pretty metre label: 10 -> "1", 15 -> "1.5"
  function metresLabel(units) {
    var m = Math.round((units / PER_M) * 10) / 10;
    return m % 1 === 0 ? m.toFixed(0) : String(m);
  }

  window.FabricUnits = { PER_M: PER_M, money: money, metresLabel: metresLabel };

  function clampMetres(input) {
    var min = parseFloat(input.min);
    if (isNaN(min)) min = 1;
    var v = parseFloat(input.value);
    if (isNaN(v)) v = min;
    v = Math.round(v * PER_M) / PER_M; // snap to 0.1
    if (v < min) v = min;
    var max = parseFloat(input.max);
    if (!isNaN(max) && v > max) v = max;
    return v;
  }

  function findContainer(input) {
    return input.closest('[data-fabric-widget]') || input.parentElement;
  }

  function updateTotal(input, units) {
    var section = input.dataset.section;
    if (!section) return;
    var unitPrice = parseInt(input.dataset.unitPrice || '0', 10); // cents / 10 cm
    var total = unitPrice * units;
    document
      .querySelectorAll('[data-fabric-total][data-section="' + section + '"]')
      .forEach(function (el) {
        el.innerHTML = money(total);
      });
    document
      .querySelectorAll('[data-fabric-total-metres][data-section="' + section + '"], [data-fabric-metres][data-section="' + section + '"]')
      .forEach(function (el) {
        el.textContent = metresLabel(units);
      });
    var metres = units / PER_M;
    document
      .querySelectorAll('[data-fabric-yards][data-section="' + section + '"]')
      .forEach(function (el) {
        el.textContent = (metres * 1.0936133).toFixed(2);
      });
  }

  // ---- MOTIF (whole-unit) purchase panel: live total + unit count ----
  function unitSync(input) {
    var section = input.dataset.section;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) qty = parseInt(input.min, 10) || 1;
    var unitPrice = parseInt(input.dataset.unitPrice || '0', 10); // cents / unit
    var total = unitPrice * qty;
    if (section) {
      document
        .querySelectorAll('[data-unit-total][data-section="' + section + '"]')
        .forEach(function (el) { el.innerHTML = money(total); });
      document
        .querySelectorAll('[data-unit-count][data-section="' + section + '"]')
        .forEach(function (el) { el.textContent = qty; });
    }
  }

  function bindUnit(input) {
    if (input.__unitBound) return;
    input.__unitBound = true;
    var handler = function () { unitSync(input); };
    input.addEventListener('change', handler);
    input.addEventListener('input', handler);
    unitSync(input);
  }

  // Keep hidden unit count + displayed value + totals consistent for one input.
  function sync(input) {
    var metres = clampMetres(input);
    var display = metres % 1 === 0 ? metres.toFixed(0) : String(metres);
    if (input.value !== display) input.value = display;

    var units = Math.round(metres * PER_M);
    var container = findContainer(input);
    var hidden = container.querySelector('input[data-fabric-units]');
    if (hidden && hidden.value !== String(units)) hidden.value = units;

    // On the product form (add-to-cart), carry the length as a line-item property
    // so it shows at checkout / on the order as "Length: X m".
    if (hidden && hidden.getAttribute('name') === 'quantity') {
      var prop = container.querySelector('input[data-fabric-length-prop]');
      if (!prop) {
        prop = document.createElement('input');
        prop.type = 'hidden';
        prop.setAttribute('data-fabric-length-prop', '');
        prop.name = 'properties[Length]';
        hidden.parentNode.insertBefore(prop, hidden.nextSibling);
      }
      prop.value = metresLabel(units) + ' m';
    }

    updateTotal(input, units);
  }

  function bind(input) {
    if (input.__fabricBound) return;
    input.__fabricBound = true;
    var handler = function () {
      sync(input);
    };
    // The +/- buttons (theme QuantityInput) dispatch a bubbling 'change'.
    input.addEventListener('change', handler);
    input.addEventListener('input', handler);
    sync(input);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('input[data-fabric]').forEach(bind);
    scope.querySelectorAll('input[data-unit][data-section]').forEach(bindUnit);
  }

  function resync() {
    document.querySelectorAll('input[data-fabric]').forEach(sync);
    document.querySelectorAll('input[data-unit][data-section]').forEach(unitSync);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    initAll(document);

    // Refresh unit price + totals when the selected variant changes on the
    // product page. The price block is re-rendered first, so re-bind after.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.price != null) {
          document.querySelectorAll('input[data-fabric]').forEach(function (input) {
            input.dataset.unitPrice = variant.price; // cents / 10 cm
          });
          document.querySelectorAll('input[data-unit][data-section]').forEach(function (input) {
            input.dataset.unitPrice = variant.price; // cents / unit
          });
        }
        // Let the DOM swap settle, then rebind + recompute.
        setTimeout(function () {
          initAll(document);
          resync();
        }, 0);
      });
    }
  });
})();
